import styled from 'styled-components';

export const Container = styled.header`
  background-color: ${({ theme }) => theme.colors.header};
  background-image: linear-gradient(
    to bottom,
    ${({ theme }) => theme.colors.header},
    rgba(250, 250, 250, 0.5)
  );

  height: 160px;
  padding: ${({ theme }) => theme.spacing.xxlg};
  padding-top: 0;
  padding-bottom: 0;

  @media (max-width: 1050px) {
    height: auto;
    padding: ${({ theme }) => theme.spacing.md};
  }

  display: flex;
  flex-direction: row;
  align-items: center;

  #resp-view {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    > div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
    }
  }

  h1,
  span {
    color: ${({ theme }) => theme.colors.headerText};
    text-transform: uppercase;
    font-weight: bold;
    font-size: 50px;
    margin-right: 20px;
  }

  span {
    margin-left: auto;
    margin-right: ${({ theme }) => theme.spacing.lg};
  }

  img {
    width: 150px;
    max-height: 100%;
    height: 100%;
    object-fit: contain;

    @media (max-width: 1050px) {
      margin-right: auto;
    }
  }
`;
